import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import adaIcon from "src/assets/images/icon_ada.svg";
import atomIcon from "src/assets/images/icon_atom.svg";
import eosIcon from "src/assets/images/icon_eos.svg";
import ethIcon from "src/assets/images/icon_eth.svg";
import irisIcon from "src/assets/images/icon_iris.svg";
import xtzIcon from "src/assets/images/icon_xtz.svg";

export const WalletSupportTokens = () => {
  return (
    <Box
      height="700px"
      p="0 155px 0 115px"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Stack>
        <Typography
          variant="bold"
          fontSize="40px"
          color="white"
          alignSelf="flex-start"
          lineHeight="40px"
        >
          Multi-chain wallet
        </Typography>

        <Typography
          color="secondary"
          fontSize="20px"
          lineHeight="20px"
          width="360px"
          mt="45px"
        >
          Wetez wallet supports multi-PoS-tokens to store, send, receive and
          delegate
        </Typography>
      </Stack>

      <Stack>
        <Typography
          variant="bold"
          fontSize="30px"
          color="white"
          alignSelf="flex-start"
          lineHeight="30px"
        >
          Token-support
        </Typography>

        <Stack mt="50px" direction="row">
          <Box width="90px" height="90px">
            <img width="100%" src={xtzIcon} alt="token icon" />
          </Box>

          <Box width="90px" height="90px" ml="44px">
            <img width="100%" src={atomIcon} alt="token icon" />
          </Box>

          <Box width="90px" height="90px" ml="44px">
            <img width="100%" src={irisIcon} alt="token icon" />
          </Box>
        </Stack>

        <Box
          width="387px"
          height="1px"
          mt="19px"
          sx={{
            backgroundColor: "#333B45",
          }}
        />

        <Typography
          variant="bold"
          fontSize="30px"
          color="white"
          alignSelf="flex-start"
          lineHeight="30px"
          mt="30px"
        >
          20+ Coming
        </Typography>

        <Stack mt="47px" direction="row">
          <Box width="90px" height="90px">
            <img width="100%" src={adaIcon} alt="token icon" />
          </Box>

          <Box width="90px" height="90px" ml="44px">
            <img width="100%" src={ethIcon} alt="token icon" />
          </Box>

          <Box width="90px" height="90px" ml="44px">
            <img width="100%" src={eosIcon} alt="token icon" />
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};
